module.exports = __webpack_public_path__ + "static/media/flag-eu.f7a59d4b.webp";